const subsidy = require('./subsidy');
const supporter = require('./supporter');
const downloader = require('./downloader');

// Runner.
(function($) {
  $().ready(function() {
    subsidy.run($);
    supporter.run($);
    downloader.run($);
  });
}(jQuery));
